import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import LoginPage from "./pages/login/social-login";
import ProfileLinkGeneratePage from "./pages/profile-link-generate";
import WelcomePage from "./pages/signup/welcome";
import ProfilePage from "./pages/profile";
import NotFound from "./pages/not-found";
import React from "react";
import TagCardPage from "./pages/tag-card";
import AgreeTermOfServicePage from "./pages/signup/agree-tos";
import {ProfileEditPage} from "./pages/profile-edit";
import {useCheckSession} from "./state/user-session";
import AccountDeletePage from "./pages/account-delete";
import {CallbackGoogleLogin} from "./pages/login/callback-google";
import {CallbackNaverLogin} from "./pages/login/callback-naver";
import {CallbackKakaoLogin} from "./pages/login/callback-kakao";


function App() {
    useCheckSession()

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/card/:cardUuid" element={<TagCardPage/>}/>
                {/*로그인*/}
                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/login/callback/google" element={<CallbackGoogleLogin/>}/>
                <Route path="/login/callback/naver" element={<CallbackNaverLogin/>}/>
                <Route path="/login/callback/kakao" element={<CallbackKakaoLogin/>}/>
                {/*회원가입*/}
                <Route path="/signup" element={<AgreeTermOfServicePage/>}/>
                <Route path="/welcome" element={<WelcomePage/>}/>
                {/*프로필*/}
                <Route path="/account/delete" element={<AccountDeletePage/>}/>

                <Route path="/profile-link-generate"
                       element={<ProfileLinkGeneratePage/>}/>
                <Route path="/profile/:link/edit"
                       element={<ProfileEditPage/>}/>

                <Route path="/:link" element={<ProfilePage/>}/>
                <Route path="/not-found" element={<NotFound/>}/>
                <Route path="*" element={<Navigate to="/not-found"/>}/>
            </Routes>
        </BrowserRouter>
    )
}

export default App;
